import { Injectable } from "@angular/core";
import { Observable, share } from "rxjs";
import { ApiDataService } from "@services/http/ApiDataService";
import { MatrixModel } from "@models/generic/MatrixModel";

@Injectable()
export class SharedDataService extends ApiDataService {
    constructor() {
        super("shared");
    }

    private _organizationMatrixRequests = new Map<number, Observable<MatrixModel>>();

    // Callers that ask for the same organization while a request is in flight share that one request.
    // A call after the response arrives sends a new request, so a changed matrix is never served stale.
    getOrganizationMatrix(organizationID: number) {
        let request = this._organizationMatrixRequests.get(organizationID);
        if (!request) {
            request = this.http
                .get<MatrixModel>(this.actionUrl + `/${organizationID}/organizationmatrix`)
                .pipe(share());
            this._organizationMatrixRequests.set(organizationID, request);
        }

        return request;
    }

    getDefaultMatrix() {
        return this.http.get<MatrixModel>(this.actionUrl + `/organizationmatrix`);
    }
}
